export default "__VITE_ASSET__B0rW3jUO__"